<template>
  <!-- // ver android, ver ios , maintenance pic , maintenance true/false -->
  <div>
    <v-card>
      <v-card-text>
        <v-card>
          <v-card-text>
            Set version
            <br>Android :
            <v-text-field></v-text-field>
            <br>IOS :
            <v-text-field></v-text-field>
          </v-card-text>
        </v-card>
        <br>
        <v-card>
          <v-card-text>
            <br>Set maintenance image :
            <v-btn @click="$refs.inputMaintenImg.click()">choose file</v-btn>
            <input
              type="file"
              @change="onSelectImage"
              style="display:none;"
              accept="image/*"
              ref="inputMaintenImg"
            >
            <br>Maintenance open/close :
            <v-switch></v-switch>
          </v-card-text>
        </v-card>
      </v-card-text>
    </v-card>
  </div>
</template>

<script>

export default {
  methods: {
    onSelectImage(event) {
      let file = event.target.files[0];
      let reader = new FileReader();
      reader.addEventListener("load", () => {});
      reader.readAsDataURL(file);
      event.target.value = "";
    }
  },
  mounted() {
    const path = [
      {
        text: "Select province",
        disabled: false,
        href:  "/weserve_admin_login/select/"
      },
      {
        text: "App Maintenance",
        disabled: true,
        href:  "/weserve_admin_login/control/-/appmaintenance"
      }
    ];
    this.$store.commit("backOffice/saveRecentRoute", path);
  }
};
</script>

<style scoped>
</style>